import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=1d3fbf78&scoped=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=ts"
export * from "./LocaleSelector.vue?vue&type=script&lang=ts"
import style0 from "./LocaleSelector.vue?vue&type=style&index=0&id=1d3fbf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3fbf78",
  null
  
)

export default component.exports